import { globalizeSelectors } from '../Utils';
import type {
  TransferAction,
  TransferAddOrderPayload,
  TransferState,
  TransferWriteResponse,
} from '../types/Transfer';
/**
 * To handle receiving and sending order to external sources
 * for example flink reading.
 *
 * NOTE: The reducer state is currently not used anywhere,
 * and the fulfilled and pending actions are not dispatched anywhere.
 */

/*
 * action types
 */

const types = {
  ADD_ORDER: 'TRANSFER/ADD_ORDER',
  ADD_ORDER_FULLFILLED: 'TRANSFER/ADD_ORDER_FULLFILLED',
  ADD_ORDER_REJECTED: 'TRANSFER/ADD_ORDER_REJECTED',
  ADD_ORDER_PENDING: 'TRANSFER/ADD_ORDER_PENDING',
} as const;

/*
 * action creators
 */

const actions = {
  addOrder: (order: TransferAddOrderPayload): TransferAction<unknown> => ({
    type: types.ADD_ORDER,
    payload: order,
  }),
};

const mountPath = 'transfer'; // mount point in global state, must match root reducer

/**
 * Handling login and log out site actions
 */

const initialState: TransferState = {
  add_order_pending: false,
  add_order_error: null,
  add_order: null,
};

function payloadAs<Payload>(action: TransferAction): Payload {
  return action.payload as Payload;
}

function reducer(
  state: TransferState = initialState,
  action: TransferAction
): TransferState {
  switch (action.type) {
    case types.ADD_ORDER_FULLFILLED: {
      return {
        ...state,
        add_order: payloadAs<TransferWriteResponse | unknown>(action),
        add_order_pending: false,
        add_order_error: null,
      };
    }
    case types.ADD_ORDER_REJECTED: {
      return {
        ...state,
        add_order: null,
        add_order_pending: false,
        add_order_error: action.payload,
      };
    }
    case types.ADD_ORDER_PENDING: {
      return {
        ...state,
        add_order: null,
        add_order_pending: true,
        add_order_error: null,
      };
    }
    default: {
      return state;
    }
  }
}

// selectors

const localSelectors = {
  busy: (state: TransferState): boolean | undefined => state.busy,
};

const selectors = globalizeSelectors(localSelectors, mountPath);

export { types as actionTypes, actions as default, selectors, reducer };
